// import React from "react";
import DrumKit from '../assets/imgs/drumKit.jpg';
import PigGame from '../assets/imgs/pigGame.mp4';
import GuessNumber from '../assets/imgs/guessnumber.mp4';
import MakeGoal from '../assets/imgs/makegoal.mp4';
import Mapty from '../assets/imgs/mapty.mp4';
import OrderFood from '../assets/imgs/orderfood.jpg';
import SimonGame from '../assets/imgs/simongame.jpg';
import Expenses from '../assets/imgs/expense.mp4';
import Easy from '../assets/imgs/easy.mp4';
import Weather from '../assets/imgs/weather.mp4';

export const ProjectData = [
  {
    id: 1,
    src: `${OrderFood}jpg`,
    site: 'http://uzfood.netlify.app',
    github: '',
    description:
      'this project is about meals which you can order online. This project is being made with a team in webbrain academy, and on the process now. As it is team work I cannot give the code, but I can show privetly!',
  },
  {
    id: 2,
    src: `${Mapty}`,
    site: 'https://maptiy.netlify.app/',
    github: 'https://github.com/Bobur98/Mapty-project',
    description:
      'Mapty website helps you to note your dayly workouts both in the list and on the map, you can choose on the map the places that you did some exercises. I made this project in one of my udemy courses with my instructor, we used html,css, JavaScript and local storage.',
  },
  {
    id: 3,
    src: `${Expenses}`,
    site: 'https://expensesnote.netlify.app/',
    github: 'https://github.com/Bobur98/ExpensesChart',
    description:
      'In this project we can add and save our expenses through out year and see some statistics about them. it was created in React.js',
  },

  {
    id: 4,
    src: `${PigGame}`,
    site: 'https://piggamee.netlify.app/',
    github: 'https://github.com/Bobur98/PigGame',
    description:
      'Famous Pig game wchich is played by two persons and rolls dices in turn to reach specified number, used html css and javaScript',
  },
  {
    id: 5,
    src: `${GuessNumber}`,
    site: 'https://guessnumberr.netlify.app/',
    github: '//github.com/Bobur98/GuessMyNumberGame',
    description:
      'it is simple game that plays one person to guess the hidden number, only html,css and javaScript was needed to make this game',
  },

  {
    id: 6,
    src: `${SimonGame}jpg`,
    site: 'https://simongamee.netlify.app/',
    github: '//github.com/Bobur98/SimonGame',
    description:
      'The Simon game is the exciting electronic game of lights and sounds in which players must repeat random sequences of lights by pressing the colored pads in the correct order.used html,css and javaScript',
  },
  {
    id: 7,
    src: `${MakeGoal}`,
    site: 'https://makegoal.netlify.app/',
    github: 'https://github.com/Bobur98/Goal-porject',
    description:
      'Basicly, this form helps to note your goals that you have made, it was created in React.js',
  },
  {
    id: 8,
    src: `${DrumKit}jpg`,
    site: 'https://drummkit.netlify.app/',
    github: 'https://github.com/Bobur98/DumKitGame',
    description:
      'lovely game for children who likes creating music, this small project was made with html, css and javaScript',
  },
  {
    id: 9,
    src: `${Easy}`,
    site: 'https://eassy.netlify.app/',
    github: 'https://github.com/Bobur98/Easy',
    description: 'Ecommerse website with nice UI in React.js',
  },
  {
    id: 10,
    src: `${Weather}`,
    site: 'https://weatheer.netlify.app/',
    github: 'https://github.com/Bobur98/ReactWeatherApp',
    description:
      'Weather application that can be found information like pressure humidity, sunset etc',
  },
];
